// Предпросмотр черновика раздела `draft:<id>` (README §10.1–10.3): черновик
// перечитывается раз в 2,5 с и рисуется тем же SectionRenderer, что и
// опубликованный раздел. Сверху — шапка «беседа / принять / отменить / версии».

import { useAppStore } from '../../store/appStore'
import { SideMenu } from '../../ui/SideMenu'
import { DraftBar } from '../custom/DraftBar'
import { overlayNote } from '../custom/overlay'
import { useSectionModel } from '../custom/model'
import { SectionCanvas, SectionSidebar } from '../custom/SectionRenderer'
import { useSections } from '../custom/store'
import { SectionStub } from '../Stub'
import type { SectionModule } from '../types'
import '../custom/custom.css'

function useDraftId(): string | null {
  const section = useAppStore((s) => s.section)
  return section.startsWith('draft:') ? section.slice(6) : null
}

function Sidebar() {
  const id = useDraftId()
  const entry = useSectionModel(id, true, false)
  const tab = useAppStore((s) => s.drafts.find((d) => d.id === `draft:${id}`))
  const focusSession = useAppStore((s) => s.focusSession)
  if (id && entry?.model) return <SectionSidebar sectionId={id} model={entry.model} draft />
  return (
    <SideMenu
      screen="draft"
      sections={[{
        id: 'draft',
        title: 'Черновик',
        items: tab?.sessionId
          ? [{ id: 'chat', label: `беседа «${tab.title}»`, live: true, onSelect: () => focusSession(tab.sessionId!) }]
          : [],
      }]}
    />
  )
}

function View() {
  const id = useDraftId()
  const entry = useSectionModel(id, true)
  const summary = useSections((s) => (id ? s.list.find((x) => x.id === id) : undefined))
  const tab = useAppStore((s) => s.drafts.find((d) => d.id === `draft:${id}`))
  if (!id) return null
  const title = entry?.model?.title ?? summary?.draftTitle ?? tab?.title ?? 'новый раздел'
  return (
    <>
      <DraftBar id={id} title={title} preview
        note={summary?.builtin ? overlayNote(id, summary.title || title, entry?.model) : null} />
      {entry?.model ? (
        <SectionCanvas sectionId={id} model={entry.model} draft />
      ) : (
        <SectionStub
          title={title}
          lead={entry?.error
            ? `черновик не читается: ${entry.error}`
            : 'Агент собирает раздел в беседе. Черновик появится здесь, как только он его запишет, — страница обновляется сама.'}
        />
      )}
    </>
  )
}

const draft: SectionModule = { Sidebar, View }
export default draft
